export default __webpack_public_path__ + "content/media/27.03220ff4.jpg";